<template lang="pug">
  div(class="container")
      line-chart(v-if="loaded" :chartdata="chartdata" :options="options" :key="componentKey")
      div(class="text-center" v-if="!loaded").mt-12
        v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
</template>

<script>
//Importing Line class from the vue-chartjs wrapper
import lineChart from "../LineChart";
//import moment from "moment";

//Exporting this so it can be used in other components
export default {
  name: "RealEstateAssessment",
  props: { duration: Number },
  components: { lineChart },
  data: () => ({
    loaded: false,
    componentKey: 0,
    chartdata: Object,
    options: {
      tooltips: {
        callbacks: {
          label: function(tooltipItem, chart) {
            var datasetLabel =
              chart.datasets[tooltipItem.datasetIndex].label || "";
            return (
              datasetLabel +
              ": " +
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0
              }).format(tooltipItem.yLabel)
            );
          }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: false,
              callback: function(value) {
                return new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0
                }).format(value);
              }
            },
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: "Average Assessment in dollars"
            }
          }
        ],
        xAxes: [
          {
            ticks: {},
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: "Period"
            }
          }
        ]
      },
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted() {
    this.getCondoData()
      .then(this.getTownhouseData)
      .then(this.getSingleFamilyData)
      .then(this.plotData);
  },

  methods: {
    getCondoData() {
      let data = [];
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/RealEstate/AnnualAssessmentsByResidentialPropertyGroup?$top=${this.duration}&$filter=residentialPropertyType eq 'Condo'&$orderby=assessedYearDate desc`
        ).then(response => {
          response.json().then(d => {
            data.push(d.sort(this.sortData("assessedYearDate")));
            resolve(data);
          });
        });
      });
    },
    getTownhouseData(data) {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/RealEstate/AnnualAssessmentsByResidentialPropertyGroup?$top=${this.duration}&$filter=residentialPropertyType eq 'Townhouse'&$orderby=assessedYearDate desc`
        ).then(response => {
          response.json().then(d => {
            data.push(d.sort(this.sortData("assessedYearDate")));
            resolve(data);
          });
        });
      });
    },
    getSingleFamilyData(data) {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/RealEstate/AnnualAssessmentsByResidentialPropertyGroup?$top=${this.duration}&$filter=residentialPropertyType eq 'Single Family Detached'&$orderby=assessedYearDate desc`
        ).then(response => {
          response.json().then(d => {
            data.push(d.sort(this.sortData("assessedYearDate")));
            resolve(data);
          });
        });
      });
    },
    sortData(prop) {
      return function(a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    plotData(data) {
      this.chartdata = {
        //Data to be represented on x-axis
        labels: [...data[0].map(d => d.assessedYearDate)],
        datasets: [
          {
            label: "Condo",
            borderColor: "orange",
            borderWidth: 2,
            pointBackgroundColor: "white",
            pointBorderColor: "orange",
            fill: false,
            //Data to be represented on y-axis
            data: [...data[0].map(d => d.averageAssessmentAmt)]
          },
          {
            label: "Townhouse",
            borderColor: "green",
            borderWidth: 2,
            pointBackgroundColor: "white",
            pointBorderColor: "green",
            fill: false,
            //Data to be represented on y-axis
            data: [...data[1].map(d => d.averageAssessmentAmt)]
          },
          {
            label: "Single Family",
            borderColor: "#005cbb",
            borderWidth: 2,
            pointBackgroundColor: "white",
            pointBorderColor: "#005cbb",
            fill: false,
            //Data to be represented on y-axis
            data: [...data[2].map(d => d.averageAssessmentAmt)]
          }
        ]
      };
      this.componentKey += 1;
      this.loaded = true;
    }
  }
};
</script>